import * as React from "react";
import styled from "styled-components";

const Box = styled.p`
	font-size: 12px;
	color: rgb(102, 102, 102);
	line-height: 16px;
	height: 16px;
	font-family: var(--fontMedium), var(--fontRegular);
`;

export interface ShipTo24HoursProps {
	text: string;
}
export const ShipTo24Hours = (props: ShipTo24HoursProps) => {
	const { text } = props;
	if (!text) {
		return null;
	}

	return <Box>{text}</Box>;
};
